var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9857 9.03646C16.8828 5.34612 13.7338 3.41359 10.5013 3.41357C7.26866 3.41354 4.11969 5.34603 2.01679 9.03637C1.64805 9.68348 1.64805 10.4769 2.01679 11.124C4.11968 14.8143 7.26866 16.7468 10.5012 16.7469C13.7338 16.7469 16.8828 14.8144 18.9857 11.1241C19.3545 10.477 19.3545 9.68357 18.9857 9.03646ZM10.1273 7.49226L9.451 8.8449C9.41068 8.92553 9.3453 8.99092 9.26466 9.03124L7.91202 9.70755C7.60492 9.86111 7.60492 10.2994 7.91202 10.4529L9.26466 11.1293C9.3453 11.1696 9.41068 11.235 9.451 11.3156L10.1273 12.6682C10.2809 12.9753 10.7191 12.9753 10.8727 12.6682L11.549 11.3156C11.5893 11.235 11.6547 11.1696 11.7353 11.1293L13.088 10.4529C13.3951 10.2994 13.3951 9.86111 13.088 9.70756L11.7353 9.03124C11.6547 8.99092 11.5893 8.92553 11.549 8.8449L10.8727 7.49226C10.7191 7.18515 10.2809 7.18515 10.1273 7.49226Z",
    fill: "#0F55DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.0a3f437889ff72050d16cb0c56647c73.svg";
export { ForwardRef as ReactComponent };